export const DEFAULT_OPTION_KEY = 'value'
export const getAllOptionsKey = (filterKey: string, optionKey: string) =>
  `${filterKey}::${optionKey}`
